/* global WD_EVENT_SUBSCRIBE_CLICK, WD_EVENT_SUBSCRIBE_SUCCESS */
// eslint-disable-next-line no-unused-vars
function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

// eslint-disable-next-line no-unused-vars
function throttle(fn, delay) {
  let lastCall = 0
  return function (...args) {
    const now = new Date().getTime()
    if (now - lastCall < delay) {
      return
    }
    lastCall = now
    fn(...args)
  }
}

const NANOID_URL_ALPHABET = 'useandom26T198340PX75klyxBvfgrUqzMtpCJQYwSHLhKjDVRiGOANbcEFZ'

function getNanoidRandomBytes(size) {
  const bytes = new Uint8Array(size)
  if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
    window.crypto.getRandomValues(bytes)
    return bytes
  }

  for (let i = 0; i < size; i++) {
    bytes[i] = Math.floor(Math.random() * 256)
  }

  return bytes
}

// eslint-disable-next-line no-unused-vars
function nanoid(size = 21, alphabet = NANOID_URL_ALPHABET) {
  return customAlphabet(alphabet, size)()
}

function customAlphabet(alphabet, defaultSize = 21) {
  const chars = typeof alphabet === 'string' && alphabet.length > 0 ? alphabet : NANOID_URL_ALPHABET
  const charsLength = chars.length
  const mask = (2 << Math.floor(Math.log2(charsLength - 1))) - 1
  const step = Math.ceil((1.6 * mask * defaultSize) / charsLength)

  return (size = defaultSize) => {
    if (!Number.isInteger(size) || size <= 0) return ''

    let id = ''
    while (id.length < size) {
      const bytes = getNanoidRandomBytes(step)
      for (let i = 0; i < step; i++) {
        const char = chars[bytes[i] & mask]
        if (!char) continue

        id += char
        if (id.length === size) return id
      }
    }

    return id
  }
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(`{"event":"command","func":"pauseVideo","args":""}`, '*')
  })
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach(video => video.pause())
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function (...rest) {
    return fn.apply(scope, rest)
  }
}

Shopify.setSelectorByValue = (selector, value) => {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i]
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
  return null
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback)
}

Shopify.postLink = function (path, options) {
  // eslint-disable-next-line no-param-reassign
  options = options || {}
  const method = options.method || 'post'
  const params = options.parameters || {}

  const form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (const key in params) {
    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

/**
 * @description 获取可聚焦元素
 * @param {Element} container 容器元素
 * @returns {Element[]} 可聚焦元素数组
 */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

const trapFocusHandlers = {}

/**
 * @description 焦点锁定，防止在弹窗时焦点丢失
 * @param {Element} container 容器元素
 * @param {Element} elementToFocus 要聚焦的元素
 */
function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container)
  const first = elements[0]
  const last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

/**
 * @description 移除陷阱聚焦
 * @param {Element} elementToFocus 要聚焦的元素
 */
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

/**
 * Splide Slider Web Component
 */
class SplideSlider extends HTMLElement {
  constructor() {
    super()
    this.slider = null
    this.observer = null
    // 是否初始化
    this.initialized = false
    // 空闲回调ID
    this.idleId = null
  }

  /**
   * 初始化
   */
  connectedCallback() {
    // 1. 读取配置：从 data-splide-options 属性中解析 JSON 配置
    // 如果没有提供，则使用空对象作为默认值
    this.options = JSON.parse(this.dataset.splideOptions || '{}')

    // 2. 懒加载判断：
    // 检查 data-lazy-load 属性（注意：HTML 中的 data-lazy-load 对应 JS 中的 dataset.lazyLoad）
    // 默认开启懒加载 (true)，除非显式设置为 'false'
    // 注意：这里使用了松散匹配，确保 undefined 或 'true' 字符串都能触发懒加载
    const { lazyLoad } = this.dataset
    if (lazyLoad === 'true' || lazyLoad === undefined) {
      this.initObserver()
      // 3. 优化：如果浏览器空闲，也尝试初始化（不必等到进入视口）
      this.initOnIdle()
    } else {
      // 如果明确关闭了懒加载，则立即初始化
      this.init()
    }
  }

  /**
   * 当元素从 DOM 中移除时调用
   * 负责清理资源，防止内存泄漏
   */
  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy() // 销毁 Splide 实例
    }
    if (this.observer) {
      this.observer.disconnect() // 停止观察
    }
    if (this.idleId && 'cancelIdleCallback' in window) {
      cancelIdleCallback(this.idleId) // 取消空闲回调
    }
  }

  /**
   * 初始化 IntersectionObserver
   * 用于检测元素是否进入视口
   */
  initObserver() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          // 当元素进入视口（isIntersecting 为 true）
          if (entry.isIntersecting) {
            this.init() // 开始下载并初始化
          }
        })
      },
      {
        // 提前200px加载
        rootMargin: '200px'
      }
    )

    this.observer.observe(this)
  }

  /**
   * 利用 requestIdleCallback 在浏览器空闲时初始化
   */
  initOnIdle() {
    if ('requestIdleCallback' in window) {
      this.idleId = requestIdleCallback(() => {
        this.init()
      })
    }
  }

  /**
   * 兜底方案：使用 script 标签降级esm加载js模块
   * @param {string} defaultUrl - 脚本 URL
   * @returns {Promise} 返回是否成功
   */
  loadViaEsmScript(defaultUrl) {
    return new Promise((resolve, reject) => {
      const url = defaultUrl.replace('.esm', '')

      // 检查是否已经有相同 URL 的 script 标签
      const existingScript = document.querySelector(`script[src="${url}"]`)
      if (existingScript) {
        existingScript.addEventListener('load', () => resolve())
        existingScript.addEventListener('error', reject)
        return
      }

      const script = document.createElement('script')
      script.src = url
      script.defer = 'true'
      script.crossOrigin = 'anonymous'

      script.onload = () => {
        resolve()
      }

      script.onerror = error => {
        console.error(`Script 加载失败: ${url}`, error)
        reject(error)
      }

      document.head.appendChild(script)
    })
  }

  /**
   * 核心初始化逻辑
   * 负责动态下载 Splide 库并挂载实例
   */
  async init() {
    // 防止重复初始化
    if (this.initialized) return
    this.initialized = true

    // 清理观察器（无论是通过视口进入触发还是空闲触发，都应该停止观察）
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }

    // 清理空闲回调
    if (this.idleId && 'cancelIdleCallback' in window) {
      cancelIdleCallback(this.idleId)
      this.idleId = null
    }

    try {
      // 获取 ESM 模块的 URL
      const { splideUrl, splideGridUrl } = this.dataset

      if (!splideUrl) {
        console.error('Splide URL not provided to splide-slider component')
        return
      }

      let Splide = null
      let Grid = null

      // 🚀 核心：动态导入 (Dynamic Import)
      // 策略 1：优先使用 ESM 动态导入
      try {
        // throw new Error('test')
        const module = await import(splideUrl)
        Splide = module.default || module.Splide

        // 加载 grid 扩展
        if (splideGridUrl && window.matchMedia('(max-width: 767px)').matches) {
          try {
            const gridModule = await import(splideGridUrl)
            ;({ Grid } = gridModule.default || gridModule)
          } catch (e) {
            console.warn('Failed to load Splide Grid extension via import():', e)
          }
        }
      } catch (importError) {
        console.warn('import() 失败，使用 script 标签兜底加载:', importError)

        // 🔄 策略 2：兜底方案 - 使用 script 标签加载
        if (!window.Splide) {
          await this.loadViaEsmScript(splideUrl)
        }

        Splide = window.Splide || window.splide?.default

        // 尝试加载 grid 扩展
        if (splideGridUrl && window.matchMedia('(max-width: 767px)').matches) {
          try {
            await this.loadViaEsmScript(splideGridUrl)
            Grid = window.splide?.Extensions?.Grid || {}
          } catch (e) {
            console.warn('Failed to load Splide Grid extension via script:', e)
          }
        }
      }

      if (!Splide) {
        throw new Error('无法加载 Splide 库')
      }

      // 初始化 Splide 实例
      this.slider = new Splide(this, this.options)

      if (Grid) {
        this.slider.mount({ Grid })
      } else {
        this.slider.mount()
      }

      // 派发自定义事件 'splide:loaded'
      this.dispatchEvent(new CustomEvent('splide:loaded', { detail: { slider: this.slider } }))
    } catch (error) {
      console.error('Error initializing Splide:', error)
    }
  }
}

// 注册自定义元素
// 使用 if 检查防止重复注册导致的报错（这在 Shopify section 重复加载时很有用）
if (!customElements.get('splide-slider')) {
  customElements.define('splide-slider', SplideSlider)
}

/* --------------------------
 * 通用加购按钮逻辑
 * ------------------------ */
;(function () {
  const SELECTOR = '[data-atc-button="true"]'

  // 防止脚本被重复执行多次（例如多次引入同一 JS）
  if (window.__COMPONENT_ATC_BUTTON_BOUND__) return
  window.__COMPONENT_ATC_BUTTON_BOUND__ = true

  /**
   * 设置按钮的 loading / idle 状态
   *
   * @param {HTMLButtonElement} button 当前按钮
   * @param {'loading' | 'idle'} state 目标状态
   * @param {MouseEvent} [evt] 原始点击事件，用于性能记录
   */
  function setButtonState(button, state, evt) {
    // Sold out 状态：不再响应 loading/idle 状态切换
    if (button.classList.contains('component-atc-button--sold-out')) return

    const spinner = button.querySelector('.loading__spinner')
    const textSpan = button.querySelector('.component-atc-button__text')

    if (state === 'loading') {
      // 禁用按钮，展示 loading
      button.setAttribute('aria-disabled', 'true')
      button.disabled = true
      button.classList.add('loading')
      if (spinner) spinner.classList.remove('hidden')

      // loading 时隐藏文案，只保留图标
      if (textSpan) textSpan.style.opacity = '0'
    } else {
      // 恢复可点击
      button.setAttribute('aria-disabled', 'false')
      button.disabled = false
      button.classList.remove('loading')
      if (spinner) spinner.classList.add('hidden')

      // 结束 loading，恢复文案显示
      if (textSpan) textSpan.style.opacity = '1'

      // 对齐 Dawn：记录用户操作完成时间
      if (state === 'idle' && window.CartPerformance?.measureFromEvent && evt) {
        window.CartPerformance.measureFromEvent('add:user-action', evt)
      }
    }
  }

  /**
   * 将按钮标记为 Sold out（前端强制缺货态）
   *
   * 用于两种情况：
   *  1. 前端根据 data-atc-available / data-atc-inventory 判断不可售
   *  2. /cart/add 接口返回 "already sold out" 等缺货错误
   *
   * @param {HTMLButtonElement} button
   */
  /**
   * 读取购物车里该变体已有的数量。
   * 限购产品无变体，购物车页和抽屉里各有一行，只取文档中的第一个，避免加总两次。
   *
   * @param {string} variantId
   * @returns {number}
   */
  function cartLineQuantity(variantId) {
    if (!/^\d+$/.test(variantId || '')) return 0
    const input = document.querySelector(
      `cart-items [data-quantity-variant-id="${variantId}"], #CartDrawer-CartItems [data-quantity-variant-id="${variantId}"]`
    )
    return parseInt(input?.value, 10) || 0
  }

  function parsePositiveInteger(value) {
    const number = parseInt(value, 10)
    return Number.isNaN(number) || number <= 0 ? 0 : number
  }

  function getAtcProductLimit(button) {
    return parsePositiveInteger(button.getAttribute('data-product-limit'))
  }

  function notifyProductLimit(limit) {
    if (typeof window.wdNotifyProductLimit === 'function') {
      window.wdNotifyProductLimit(limit)
    } else if (typeof window.showToast === 'function') {
      window.showToast({
        message: `You already have this pass in your cart. Limit ${limit} per customer.`,
        type: 'warning'
      })
    }
  }

  function notifyAtcError(variantId, error) {
    try {
      document.dispatchEvent(
        new CustomEvent('component:cart:error', {
          detail: {
            source: 'component-atc-button',
            variantId,
            error,
            message: 'Add to cart failed. Please try again.'
          }
        })
      )
    } catch (dispatchError) {
      console.error(dispatchError)
    }
  }

  function markSoldOut(button) {
    const textSpan = button.querySelector('.component-atc-button__text') || button
    const spinner = button.querySelector('.loading__spinner')

    // 优先使用 window.variantStrings.soldOut（Dawn 内置文案），否则使用 Liquid 注入的翻译
    const soldOutText = (window.variantStrings && window.variantStrings.soldOut) || '{{ sold_out_text | escape }}'

    // 额外 Sold out 样式 class，从 Liquid 通过 data-atc-sold-out-class 注入
    const extraClass = button.getAttribute('data-atc-sold-out-class')

    button.classList.add('component-atc-button--sold-out')
    if (extraClass) {
      button.classList.add(extraClass)
    }

    // 永久禁用按钮
    button.setAttribute('aria-disabled', 'true')
    button.disabled = true

    // Sold out 必须展示文案
    if (textSpan) {
      textSpan.textContent = soldOutText
      textSpan.style.opacity = '1'
    }

    // 不再展示 loading
    if (spinner) spinner.classList.add('hidden')

    // 同步 data-* 属性，避免后续逻辑再误判为可售
    button.dataset.atcAvailable = 'false'
    button.dataset.atcInventory = '0'
  }

  /**
   * 全局 click 事件代理
   * - 通过事件冒泡捕获所有 data-atc-button="true" 的按钮点击
   * - 避免每个按钮都单独绑定事件，提高性能和兼容动态渲染
   */
  document.addEventListener('click', event => {
    const button = event.target.closest(SELECTOR)
    if (!button) return

    // 避免重复点击：已被禁用（aria-disabled = true）则直接返回
    if (button.getAttribute('aria-disabled') === 'true') return

    const id = button.getAttribute('data-atc-id')
    const qty = button.getAttribute('data-atc-qty') || '1'
    const bundleIds = button.getAttribute('data-atc-bundle-ids')

    // 库存相关 data 属性（由 Liquid 注入）
    const inventoryAttr = button.getAttribute('data-atc-inventory')
    const inventory = inventoryAttr === null || inventoryAttr === '' ? null : parseInt(inventoryAttr, 10)

    const inventoryPolicy = button.getAttribute('data-atc-inventory-policy') || ''
    const inventoryManagement = button.getAttribute('data-atc-inventory-management') || ''
    const availableAttr = button.getAttribute('data-atc-available')

    // available 布尔值解析（字符串 → 布尔）
    const available = availableAttr === 'true' || availableAttr === '1' || availableAttr === 'True'

    // ------------------------------
    // 本地库存/可售状态防御
    // bundle 的可售状态由组成变体决定，不使用父变体库存
    // ------------------------------
    let shouldBlock = false

    // 1）变体整体不可售 (available = false)
    if (!bundleIds && !available && availableAttr !== null) {
      shouldBlock = true
    }
    // 2）有库存管理 && 不允许缺货继续售卖 && 库存 <= 0
    else if (
      !bundleIds &&
      inventoryManagement && // 有库存管理
      inventoryPolicy !== 'continue' && // 不允许超卖
      inventory !== null && // 有库存数据
      !Number.isNaN(inventory) &&
      inventory <= 0
    ) {
      shouldBlock = true
    }

    if (shouldBlock) {
      // 直接前端拦截，标记为 Sold out，不再发送请求
      markSoldOut(button)

      // 派发一个 soldout 事件，方便其它脚本监听（展示 Toast/埋点等）
      try {
        const soldOutEvt = new CustomEvent('component:cart:soldout', {
          detail: {
            source: 'component-atc-button',
            variantId: id,
            inventory,
            inventoryPolicy,
            inventoryManagement
          }
        })
        document.dispatchEvent(soldOutEvt)
      } catch (error) {
        console.error(error)
      }

      return
    }

    // 没有变体 id，无法加购。bundle 使用组成变体 id
    if (!id && !bundleIds) {
      console.error('ATC: missing data-atc-id')
      return
    }

    const productLimit = getAtcProductLimit(button)
    if (productLimit > 0) {
      const requestedQty = parsePositiveInteger(qty) || 1
      const inCart = cartLineQuantity(id)
      if (requestedQty > productLimit || inCart + requestedQty > productLimit) {
        notifyProductLimit(productLimit)
        return
      }
    }

    // 进入 loading 状态，避免加购请求完成前重复点击
    setButtonState(button, 'loading', event)

    // ------------------------------
    // /cart/add 请求配置：优先使用 Dawn 的 fetchConfig
    // ------------------------------
    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }

    // 强制 XHR 标记，去掉 Content-Type（FormData 自带）
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    const formData = new FormData()
    if (!bundleIds) {
      formData.append('id', id)
      formData.append('quantity', qty)
    }

    // Dawn 的 cart-drawer / cart-items 组件（如存在，则局部刷新购物车）
    // 如果在购物车页面，优先使用 cart-items；否则优先使用 cart-drawer
    const isCartPage =
      window.ShopifyAnalytics?.meta?.page?.pageType === 'cart' ||
      !!document.querySelector('cart-items') ||
      (() => {
        const cartUrl = window.routes?.cart_url || '/cart'
        const normalizedPath = window.location.pathname.replace(/\/+$/, '')
        const normalizedCart = cartUrl.replace(/\/+$/, '')
        return normalizedPath.endsWith(normalizedCart)
      })()
    let cart

    if (isCartPage) {
      // 在购物车页面，优先使用 cart-items
      cart = document.querySelector('cart-items') || document.querySelector('cart-drawer')
    } else {
      // 在其他页面，优先使用 cart-drawer
      cart = document.querySelector('cart-drawer') || document.querySelector('cart-items')
    }

    // 显示购物车加载状态（进度条和蒙版）
    if (cart && typeof cart.enableLoading === 'function') {
      cart.enableLoading(0) // 加购时不需要 line 参数，传递 0
    }

    let sectionIds = []
    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sections = cart.getSectionsToRender()
      // Shopify 需要的是 section ID（section.section），不是 DOM 元素的 id（section.id）
      sectionIds = sections.map(section => section.section || section.id).filter(Boolean)
    } else {
      console.warn('ATC: Cart component found but getSectionsToRender not available', cart)
    }

    const baseAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add'
    let addUrl = baseAddUrl

    if (bundleIds) {
      const bundleTitle = button.getAttribute('data-atc-bundle-title') || ''
      const quantity = Number.parseInt(qty, 10) || 1
      const items = bundleIds
        .split(';')
        .filter(Boolean)
        .map(bundle => {
          const [variantId, bundleQuantity] = bundle.split(':')
          return {
            quantity: (Number.parseInt(bundleQuantity, 10) || 1) * quantity,
            id: variantId,
            properties: {
              'Part Of': bundleTitle.replace('||', ' '),
              __is_bundle: bundleIds,
              __bundle_img: button.getAttribute('data-atc-bundle-img') || '',
              __bundle_url: button.getAttribute('data-atc-bundle-url') || '',
              __bundle_title: bundleTitle,
              __bundle_price: button.getAttribute('data-atc-bundle-price') || ''
            }
          }
        })

      config.headers['Content-Type'] = 'application/json'
      config.body = JSON.stringify({
        items,
        ...(sectionIds.length ? { sections: sectionIds.join(','), sections_url: window.location.pathname } : {})
      })
      addUrl = `${baseAddUrl.replace(/\.js$/, '')}.js`
    } else {
      if (sectionIds.length > 0) {
        formData.append('sections', sectionIds.join(','))
        formData.append('sections_url', window.location.pathname)
      }
      config.body = formData
    }

    // ------------------------------
    // /cart/add 请求主流程
    // ------------------------------
    fetch(addUrl, config)
      .then(response => response.json())
      .then(response => {
        // ❌ 业务错误（如缺货、限购等）
        if (response.status) {
          const msg = response.description || response.message || 'Add to cart failed. Please try again.'
          console.error('ATC error:', msg, response)

          // 发布 Dawn 的 cartError 事件，保持与主题内部逻辑兼容
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartError, {
              source: 'component-atc-button',
              productVariantId: id,
              errors: response.errors || response.description,
              message: response.message
            })
          }

          // 自定义错误事件：方便全局监听并做统一错误处理（如 Toast）
          try {
            const evt = new CustomEvent('component:cart:error', {
              detail: {
                source: 'component-atc-button',
                variantId: id,
                response,
                message: msg
              }
            })
            document.dispatchEvent(evt)
          } catch (error) {
            console.error(error)
          }

          // 根据接口返回内容判断是否已售罄（含 "is already sold out."）
          try {
            const combined = [response.description, response.message, JSON.stringify(response.errors || '')]
              .filter(Boolean)
              .join(' | ')
              .toLowerCase()

            if (combined.includes('already sold out') || combined.includes('sold out')) {
              markSoldOut(button)
            }
          } catch (error) {
            console.error(error)
          }

          return
        }

        // ✅ 加购成功埋点上报
        if (typeof window.WDSendEvent === 'function') {
          const eventCategory = button.getAttribute('data-event-category') || ''
          const eventSku = button.getAttribute('data-event-sku') || ''
          window.WDSendEvent('wd_add_to_cart', {
            event_source: window.location.pathname,
            event_category: eventCategory,
            event_action: eventSku
          })
        }

        // ✅ 请求成功：如果没有 cart 组件，直接跳转购物车页
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart'
          return
        }

        // 使用 Dawn 的 Pub/Sub 通知其他订阅者（例如 header 购物车数量）
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          const startMarker =
            window.CartPerformance &&
            window.CartPerformance.createStartingMarker &&
            window.CartPerformance.createStartingMarker('add:wait-for-subscribers')

          window
            .publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'component-atc-button',
              productVariantId: id,
              cartData: response
            })
            .then(() => {
              if (window.CartPerformance?.measureFromMarker && startMarker) {
                window.CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker)
              }
            })
        }

        // 渲染 cart-drawer / cart-items 内容

        if (typeof cart.renderContents === 'function') {
          if (window.CartPerformance?.measure) {
            window.CartPerformance.measure('add:paint-updated-sections', () => {
              cart.renderContents(response)
            })
          } else {
            cart.renderContents(response)
          }
        } else {
          // 如果没有 renderContents 方法，回退到 onCartUpdate
          console.warn('Cart component does not have renderContents method, falling back to onCartUpdate')
          if (typeof cart.onCartUpdate === 'function') {
            cart.onCartUpdate()
          }
        }

        // 隐藏加载状态
        if (cart && typeof cart.disableLoading === 'function') {
          cart.disableLoading(0)
        }
      })
      .catch(error => {
        // ❌ 网络/JS 异常
        console.error('ATC fetch error:', error)
        notifyAtcError(id, error)
      })
      .finally(() => {
        // 无论成功失败都恢复按钮状态（除非已经被 markSoldOut）
        setButtonState(button, 'idle', event)

        // Dawn：如果 cart 组件在 empty 状态，加购后移除 is-empty
        const cartInner = document.querySelector('cart-drawer') || document.querySelector('cart-items')
        if (cartInner && cartInner.classList.contains('is-empty')) {
          cartInner.classList.remove('is-empty')
        }

        // 确保加载状态已隐藏（finally 块中的兜底）
        if (cart && typeof cart.disableLoading === 'function') {
          cart.disableLoading(0)
        }
      })
  })
})()

/* --------------------------
 * 通用 Buy Now 按钮逻辑（表单提交）
 * ------------------------ */
;(function () {
  const FORM_SELECTOR = 'form[data-component-buy-now-form="true"]'
  const BUTTON_SELECTOR = '[data-component-buy-now-button="true"]'

  if (window.__COMPONENT_BUY_NOW_BUTTON_BOUND__) return
  window.__COMPONENT_BUY_NOW_BUTTON_BOUND__ = true

  function setBuyNowButtonState(button, state) {
    const spinner = button.querySelector('.loading__spinner')
    const textSpan = button.querySelector('.component-atc-button__text')

    if (state === 'loading') {
      button.setAttribute('aria-disabled', 'true')
      button.disabled = true
      button.classList.add('loading')
      if (spinner) spinner.classList.remove('hidden')
      if (textSpan) textSpan.style.opacity = '0'
    } else {
      button.setAttribute('aria-disabled', 'false')
      button.disabled = false
      button.classList.remove('loading')
      if (spinner) spinner.classList.add('hidden')
      if (textSpan) textSpan.style.opacity = '1'
    }
  }

  function initBuyNowButtons() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(button => {
      setBuyNowButtonState(button, 'idle')
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyNowButtons)
  } else {
    initBuyNowButtons()
  }

  window.addEventListener('pageshow', () => {
    initBuyNowButtons()
  })

  document.addEventListener('load-more:complete', initBuyNowButtons)

  document.addEventListener('submit', event => {
    const form = event.target.closest(FORM_SELECTOR)
    if (!form) return

    const { submitter } = event
    if (!submitter?.matches(BUTTON_SELECTOR)) return

    event.preventDefault()

    const formData = new FormData(form)
    const variantId = formData.get('id')
    const quantity = formData.get('quantity') || '1'

    if (!variantId) {
      console.error('Buy Now: missing variant id')
      return
    }

    setBuyNowButtonState(submitter, 'loading')

    const cartUrl = (window.routes && window.routes.cart_url) || '/cart'
    window.location.href = `${cartUrl}/${variantId}:${quantity}`
  })
})()

/* --------------------------
 * Component Purchase Actions 表单加购逻辑
 * 从 snippet 移入 common.js，保持原有行为
 * ------------------------ */
;(() => {
  function initPurchaseActions() {
    document.querySelectorAll('[data-component-purchase-actions]').forEach(wrapper => {
      if (wrapper.dataset.atcInited === '1') return
      wrapper.dataset.atcInited = '1'

      const form = wrapper.querySelector('form[data-type="add-to-cart-form"]')
      if (!form) return
      const btn = wrapper.querySelector('[data-atc-button]')
      const _label = btn && btn.querySelector('[data-atc-label]')
      const errWrap = wrapper.querySelector('.product-form-error-message-wrapper')
      const errMsg = errWrap && errWrap.querySelector('.product-form-error-message')

      function setError(message) {
        if (!errWrap || !errMsg) return
        errMsg.textContent = message || 'Something went wrong.'
        errWrap.hidden = false
        errWrap.removeAttribute('hidden')
      }

      function clearError() {
        if (!errWrap) return
        errWrap.hidden = true
        errWrap.setAttribute('hidden', '')
      }

      function setLoading(isLoading) {
        if (!btn) return

        const spinner = btn.querySelector('[data-atc-spinner]')
        const labelEl = btn.querySelector('[data-atc-label]')

        if (isLoading) {
          btn.setAttribute('aria-disabled', 'true')
          btn.classList.add('loading')
          if (labelEl) labelEl.classList.add('hidden')
          if (spinner) spinner.classList.remove('hidden')
        } else {
          btn.removeAttribute('aria-disabled')
          btn.classList.remove('loading')
          if (labelEl) labelEl.classList.remove('hidden')
          if (spinner) spinner.classList.add('hidden')
        }
      }

      form.addEventListener('submit', async e => {
        e.preventDefault()
        clearError()

        const cart = document.querySelector('cart-drawer')

        // 如果主题没有启用 drawer，回退到购物车页
        if (!cart) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart'
          return
        }

        // Dawn 的 cart-drawer 通常会提供 getSectionsToRender()
        const sectionIds =
          typeof cart.getSectionsToRender === 'function' ? cart.getSectionsToRender().map(s => s.id) : []

        const formData = new FormData(form)
        if (sectionIds.length) formData.append('sections', sectionIds.join(','))
        formData.append('sections_url', window.location.pathname)

        setLoading(true)

        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add'

        try {
          const res = await fetch(addUrl, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json'
            },
            body: formData
          })

          const data = await res.json()

          // Shopify 错误返回通常带 status/description
          if (data && data.status) {
            setError(data.description || 'Unable to add to cart.')
            setLoading(false)
            return
          }

          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty')
          if (typeof cart.renderContents === 'function') cart.renderContents(data)
        } catch {
          setError('Something went wrong. Please try again.')
        } finally {
          setLoading(false)
          if (btn) btn.blur()
          // 不强行重置文案，避免覆盖 Sold Out / 多语言 / 其他状态
        }
      })
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPurchaseActions)
  } else {
    initPurchaseActions()
  }
})()

/**
 * @description 拦截带 iso 属性的链接，在跳转路径前补充语言路径前缀
 */
function initIsoLinkInterceptor() {
  document.addEventListener(
    'click',
    event => {
      if (event.defaultPrevented) return

      const { target } = event
      const clickedElement = target instanceof Element ? target : null
      const link = clickedElement?.closest('a[iso][href]')
      if (!link) return
      const iso = link.getAttribute('iso')
      if (iso === 'en') return

      const isoUrl = buildIsoLinkUrl(link.getAttribute('href'), link.getAttribute('iso'))
      if (!isoUrl) return

      link.href = isoUrl
    },
    true
  )
}

function buildIsoLinkUrl(href, iso) {
  const isoPrefix = normalizeIsoPrefix(iso)
  if (!href || !isoPrefix) return ''

  let url
  try {
    url = new URL(href, window.location.origin)
  } catch {
    return ''
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return ''

  const pathname = url.pathname === '/' ? '' : url.pathname
  if (pathname === isoPrefix || pathname.startsWith(`${isoPrefix}/`)) return url.toString()

  url.pathname = `${isoPrefix}${pathname}`
  return url.toString()
}

function normalizeIsoPrefix(iso) {
  if (!iso) return ''

  let isoPrefix = iso.trim()
  if (!isoPrefix) return ''

  if (!isoPrefix.startsWith('/')) {
    isoPrefix = `/${isoPrefix}`
  }

  return isoPrefix.replace(/\/+$/, '')
}

initIsoLinkInterceptor()

/**
 * @description Sentry 上报错误
 */
// eslint-disable-next-line no-unused-vars
class ReportSentry {
  /**
   * @description 错误名称枚举
   */
  static ERROR_NAMES = {
    CART_ADD_ERROR: 'CartAddError',
    GET_CART_INFO_ERROR: 'GetCartInfoError'
  }

  /**
   * @description 模块名称枚举
   */
  static MODULES = {
    CART: 'cart'
  }

  static capture({ name, message, error, tags = {}, extra = {} }) {
    if (!window.Sentry) return

    const finalError = error instanceof Error ? error : new Error(message || 'Unknown error')

    finalError.name = name

    window.Sentry.captureException(finalError, { tags, extra })
  }

  static cartAddError({ variantId, quantity, response, error, isNetworkError = false }) {
    const message = response?.message || response?.description || error?.message || 'Cart add failed'

    ReportSentry.capture({
      name: ReportSentry.ERROR_NAMES.CART_ADD_ERROR,
      message,
      error,
      tags: {
        type: 'fetch',
        module: ReportSentry.MODULES.CART,
        action: 'add',
        network: isNetworkError ? 'true' : 'false'
      },
      extra: {
        url: window.routes?.cart_add_url,
        variantId,
        quantity,
        status: response?.status,
        errors: response?.errors,
        description: response?.description,
        response,
        online: navigator.onLine
      }
    })
  }

  /**
   * @description 上报 fetch 错误
   * @param {string} name 错误名称
   * @param {string} url 请求 URL
   * @param {Error} error 错误对象
   * @param {Object} response 响应对象
   * @param {Object} tags {action: string, module: string}
   */
  static fetchError({ name, url, error, response, tags }) {
    const message = response?.message || response?.description || error?.message || 'Fetch failed'

    ReportSentry.capture({
      name,
      message,
      error,
      tags: { type: 'fetch', network: 'true', ...tags },
      extra: {
        url,
        status: response?.status,
        errors: response?.errors,
        description: response?.description,
        response,
        online: navigator.onLine
      }
    })
  }

  //- 用于上报购物车更新/删除错误，区分更新和删除操作。
  static cartUpdateError({ line, quantity, response, error, isNetworkError = false }) {
    const message = response?.message || response?.description || error?.message || 'Cart update failed'
    const isDelete = quantity === 0

    ReportSentry.capture({
      name: 'CartUpdateError',
      message,
      error,
      tags: {
        type: 'fetch',
        module: 'cart',
        action: isDelete ? 'delete' : 'update',
        network: isNetworkError ? 'true' : 'false'
      },
      extra: {
        url: window.routes?.cart_change_url,
        line,
        quantity,
        isDelete,
        status: response?.status,
        errors: response?.errors,
        description: response?.description,
        response,
        online: navigator.onLine
      }
    })
  }
}

//- Web Components

class ComponentVideo extends HTMLElement {
  constructor() {
    super()
    // 存储视频播放器实例
    this._playerInstance = null
    // 标记用户是否手动暂停过视频
    this._pausedByUser = false
    // 检查是否为 YouTube 视频
    this._isYouTube = false
  }

  connectedCallback() {
    // 检查是否为 YouTube 视频
    if (this.hasAttribute('is-youtube')) {
      this._isYouTube = true
      // YouTube 视频立即加载
      this.loadPlayer()
    }
    this.init()
  }

  init() {
    if (this.playBtn) {
      this.playBtn.addEventListener('click', this.onPlayBtnClick.bind(this))
    }

    if (this.autoplay) {
      this.initAutoplayObserver()
    }
  }

  /* --------------------------
   * Getters（获取器）
   * ------------------------ */
  // 获取播放按钮元素
  get playBtn() {
    return this.querySelector('[id^="Deferred-PlayBtn-"]')
  }

  // 检查是否有 autoplay 属性
  get autoplay() {
    return this.hasAttribute('autoplay')
  }

  // 检查视频是否正在播放
  get playing() {
    return this.hasAttribute('playing')
  }

  // 监听 playing 属性变化
  static get observedAttributes() {
    return ['playing']
  }

  /* --------------------------
   * IntersectionObserver → 自动播放逻辑
   * ------------------------ */
  initAutoplayObserver() {
    this._autoplayObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this._pausedByUser) {
          this.play()
        } else {
          this.pause()
        }
      })
    })
    this._autoplayObserver.observe(this)
  }

  disconnectedCallback() {
    if (this._autoplayObserver) {
      this._autoplayObserver.disconnect() // 元素移除时停止观察
    }
  }

  /* --------------------------
   * 加载播放器（从 template 标签提取视频元素）
   * 使用懒加载，只在需要时才加载视频
   * 支持 HTML5 video 和 YouTube iframe
   * ------------------------ */
  loadPlayer() {
    // 如果已加载过，直接返回缓存的播放器实例
    if (this._playerInstance) return this._playerInstance

    // 从 template 标签中提取视频元素
    const template = this.querySelector('template')
    if (template) {
      const el = template.content.firstElementChild.cloneNode(true)
      this.appendChild(el)
      template.remove()
    }

    this.setAttribute('loaded', '')
    this.closest('.media')?.classList.remove('loading')

    // 检查是否为 YouTube iframe
    const iframe = this.querySelector('iframe')
    if (iframe) {
      this._isYouTube = true
      this._playerInstance = iframe
      return iframe
    }

    const video = this.querySelector('video')

    if (!video) return null

    // 绑定视频事件
    // 视频播放时，设置 playing 属性并移除 suspended 属性
    video.addEventListener('play', () => {
      this.setAttribute('playing', '')
      this.removeAttribute('suspended')
    })

    // 视频暂停时，移除 playing 属性
    video.addEventListener('pause', () => {
      this.removeAttribute('playing')
      // 防止在用户拖动进度条时误触发暂停逻辑
      // if (!video.seeking && video.paused) {
      //   this.removeAttribute('playing')
      // }
    })

    // 自动播放或移动端时需要静音（浏览器限制）
    const shouldMute = this.autoplay || window.matchMedia('(max-width: 1023px)').matches
    if (shouldMute) video.muted = true

    this._playerInstance = video
    return video
  }

  /* --------------------------
   * 播放/暂停 API
   * YouTube 视频使用原生播放器，不进行播放控制
   * 仅对 HTML5 video 进行播放控制
   * ------------------------ */
  play() {
    const player = this.loadPlayer()
    if (!player) return

    // YouTube 视频使用原生播放器，不需要处理
    if (this._isYouTube) {
      return
    }

    // 如果已在播放，则不重复调用
    if (this.playing) return

    // 尝试播放，捕获自动播放被拒绝的错误
    player.play().catch(err => {
      if (err.name === 'NotAllowedError') {
        // 浏览器禁止自动播放
        this.setAttribute('suspended', '')
        // 显示播放控制条，让用户手动点击播放
        player.controls = true

        // 用前一个兄弟元素（通常是封面图）的 src 替换视频 poster
        const replacementPoster = player.previousElementSibling?.currentSrc
        if (replacementPoster) player.poster = replacementPoster
      }
    })
  }

  pause() {
    const player = this._playerInstance
    if (!player) return
    if (!this.playing) return

    // YouTube 视频使用原生播放器，不需要处理
    if (this._isYouTube) {
      return
    }

    player.pause()
  }

  /* --------------------------
   * 播放按钮点击事件 → 切换播放/暂停
   * ------------------------ */
  onPlayBtnClick(e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.playing) {
      this._pausedByUser = true
      this.pause()
    } else {
      this._pausedByUser = false
      this.play()
    }
  }

  /* --------------------------
   * 属性变化回调 → 派发自定义事件
   * 当 playing 属性改变时，派发对应的事件
   * 允许其他代码监听视频播放状态变化
   * ------------------------ */
  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'playing') {
      if (oldVal === null && newVal === '') {
        this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }))
      }
      if (newVal === null) {
        this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }))
      }
    }
  }

  /* --------------------------
   * 重置视频播放器
   * video => 暂停并回到第一帧
   * youtube => 重置 src
   * ------------------------ */
  reset() {
    const videoElement = this._playerInstance
    if (videoElement) {
      this._pausedByUser = true
      if (videoElement.nodeName === 'VIDEO') {
        if (this.playing) this.pause()
        videoElement.currentTime = 0
      }

      if (videoElement.nodeName === 'IFRAME') {
        const originalSrc = videoElement.getAttribute('src')
        videoElement.src = 'about:blank'
        setTimeout(() => {
          if (originalSrc) {
            videoElement.src = originalSrc
          }
        }, 0)
      }

      if (videoElement.nodeName === 'MODEL-VIEWER' && videoElement.modelViewerUI) {
        videoElement.modelViewerUI.resetCamera()
      }
    }
  }
}

customElements.define('component-video', ComponentVideo)

/**
 * @description 弹窗组件 <modal-dialog>
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', this.hide.bind(this, false))
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', event => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '')
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    pauseAllMedia()
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    document.body.dispatchEvent(new CustomEvent('modalClosed'))
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    pauseAllMedia()
  }
}

customElements.define('modal-dialog', ModalDialog)

/**
 * @description <sidebar-container>
 * use with <sidebar-opener>
 */
class SidebarContainer extends HTMLElement {
  static pageScrollLocked = false
  static savedScrollY = 0

  constructor() {
    super()
    this._onDocumentKeydown = this._onDocumentKeydown.bind(this)
    this._onTouchMove = this._onTouchMove.bind(this)
    this.querySelector('[id^="SidebarClose-"]')?.addEventListener('click', this.hide.bind(this, false))
    this.addEventListener('click', event => {
      if (event.target === this) {
        this.hide()
      }
    })
    this.addEventListener('touchmove', this._onTouchMove, { passive: false })
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  _onDocumentKeydown(event) {
    if (event.code !== 'Escape' && event.key !== 'Escape') return
    if (!this.hasAttribute('open')) return
    event.preventDefault()
    this.hide()
  }

  _isMobileSidebar() {
    return window.matchMedia('(max-width: 767px)').matches
  }

  _onTouchMove(event) {
    if (!this.hasAttribute('open') && !this.classList.contains('closing')) return
    if (!this._isMobileSidebar()) return
    if (event.target === this) event.preventDefault()
  }

  _lockPageScroll() {
    if (SidebarContainer.pageScrollLocked) return
    SidebarContainer.pageScrollLocked = true
    SidebarContainer.savedScrollY = window.scrollY || document.documentElement.scrollTop || 0
    document.documentElement.classList.add('sidebar-open')
    document.body.classList.add('sidebar-open')
    document.body.style.top = `-${SidebarContainer.savedScrollY}px`
  }

  _unlockPageScroll() {
    if (!SidebarContainer.pageScrollLocked) return
    SidebarContainer.pageScrollLocked = false
    document.documentElement.classList.remove('sidebar-open')
    document.body.classList.remove('sidebar-open')
    document.body.style.top = ''
    window.scrollTo(0, SidebarContainer.savedScrollY || 0)
  }

  _syncPageScrollLock() {
    const busy = document.querySelector('sidebar-container[open], sidebar-container.closing')
    if (this._isMobileSidebar() && busy) {
      this._lockPageScroll()
      return
    }
    this._unlockPageScroll()
  }

  show(opener) {
    this.openedBy = opener
    clearTimeout(this.closeTimer)
    this.classList.remove('closing')
    this.setAttribute('open', '')
    document.addEventListener('keydown', this._onDocumentKeydown, true)
    trapFocus(this)
    this._syncPageScrollLock()

    this.dispatchEvent(new CustomEvent('sidebar:show', { detail: { opener: this.openedBy, container: this } }))
  }

  hide() {
    if (this.classList.contains('closing')) return
    this.classList.add('closing')
    this.removeAttribute('open')
    document.removeEventListener('keydown', this._onDocumentKeydown, true)
    removeTrapFocus(this.openedBy)
    clearTimeout(this.closeTimer)
    this.closeTimer = setTimeout(() => {
      this.classList.remove('closing')
      this._syncPageScrollLock()
    }, 300)
  }
}

customElements.define('sidebar-container', SidebarContainer)

/**
 * @description <sidebar-opener>
 */
class SidebarOpener extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', this.showSidebar.bind(this))
    this.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    this.showSidebar()
  }

  showSidebar() {
    const sidebarId = this.closest('sidebar-opener').dataset.sidebar
    if (!sidebarId) return
    const sidebar = document.getElementById(sidebarId)
    if (sidebar) sidebar.show(this)
  }
}

customElements.define('sidebar-opener', SidebarOpener)

/**
 * @description <modal-container>
 */
class ModalContainer extends HTMLElement {
  constructor() {
    super()
    this.handleKeydown = this.handleKeydown.bind(this)
    this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', this.hide.bind(this))
    this.addEventListener('click', event => {
      if (event.target === this) {
        this.hide()
      }
    })
  }

  connectedCallback() {
    if (!this.moved) {
      this.moved = true
      document.body.appendChild(this)
    }
    if (!this.escapeListenerRegistered) {
      document.addEventListener('keydown', this.handleKeydown)
      this.escapeListenerRegistered = true
    }
  }

  disconnectedCallback() {
    if (!this.escapeListenerRegistered) return
    document.removeEventListener('keydown', this.handleKeydown)
    this.escapeListenerRegistered = false
  }

  handleKeydown(event) {
    if (!this.hasAttribute('open')) return
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.hide()
    }
  }

  show(opener, onOpened) {
    const wasOpen = this.hasAttribute('open')
    this.openedBy = opener
    this.onOpened = typeof onOpened === 'function' ? onOpened : null
    clearTimeout(this.closeTimer)
    clearTimeout(this.openTimer)
    this.classList.remove('closing')
    this.setAttribute('open', '')
    this.dispatchEvent(new CustomEvent('modal:show', { detail: { opener: this.openedBy, container: this } }))

    if (wasOpen) {
      this.notifyOpened()
      return
    }

    this.openTimer = setTimeout(() => this.notifyOpened(), 200)
  }

  notifyOpened() {
    if (!this.hasAttribute('open')) return
    this.dispatchEvent(new CustomEvent('modal:opened', { detail: { opener: this.openedBy, container: this } }))
    this.onOpened?.()
    this.onOpened = null
  }

  hide() {
    if (!this.hasAttribute('open')) return
    this.classList.remove('closing')
    this.removeAttribute('open')
    this.onOpened = null
    clearTimeout(this.openTimer)
    clearTimeout(this.closeTimer)
    this.dispatchEvent(new CustomEvent('modal:hide', { detail: { container: this }, bubbles: true }))
  }
}

customElements.define('modal-container', ModalContainer)

/** 14×14 downward chevron, same geometry as assets/icon-chevron-down.svg */
const LOAD_MORE_CHEVRON_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" aria-hidden="true"><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.25" d="m2 4.5 5 5 5-5"/></svg>'

/**
 * Appends a "View More" button to containerEl.
 * Handles loading state: on click the button is disabled with "Loading…" text;
 * if onClick rejects, the button is restored automatically.
 * variant "text" renders the site text button (14px, tertiary, chevron).
 */
// eslint-disable-next-line no-unused-vars
function createLoadMoreButton({ containerEl, wrapClass, onClick, variant = 'outlined' }) {
  containerEl.querySelector(`.${wrapClass}`)?.remove()
  const wrap = document.createElement('div')
  wrap.className = wrapClass

  const isText = variant === 'text'
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.className = isText ? 'text-button text-button-m' : 'primary-button-outlined'

  const setLabel = label => {
    btn.replaceChildren(document.createTextNode(label))
    if (isText && label === 'View More') {
      btn.insertAdjacentHTML('beforeend', LOAD_MORE_CHEVRON_SVG)
    }
  }

  setLabel('View More')
  btn.addEventListener('click', async () => {
    btn.disabled = true
    setLabel('Loading...')
    try {
      await onClick()
    } catch {
      btn.disabled = false
      setLabel('View More')
    }
  })

  wrap.appendChild(btn)
  containerEl.appendChild(wrap)
}

/**
 * @description <modal-opener>
 */
class ModalOpener extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', this.showModal.bind(this))
  }

  showModal(e) {
    e.preventDefault()
    const modalId = this.dataset.modal
    if (!modalId) return
    const modal = document.getElementById(modalId)
    if (modal) modal.show(this)
  }
}

customElements.define('modal-opener', ModalOpener)

/**
 * 复制文本到剪贴板（优化版）
 * @param {string} text - 要复制的文本
 * @returns {Promise} - 成功时解析，失败时拒绝
 */
function copyTextProductCard(text) {
  // 现代浏览器：使用 Clipboard API（96%+ 浏览器支持）
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text)
  }

  // 降级方案：使用 execCommand（已废弃但仍可用）
  // 注意：execCommand 已被废弃，但作为降级方案保留
  // 仅在极少数旧版浏览器（< 4%）中触发
  return new Promise((resolve, reject) => {
    try {
      // 创建临时文本域（优化：最小化样式设置）
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.setAttribute('readonly', '')
      textarea.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0'

      document.body.appendChild(textarea)

      // 选中并复制
      textarea.select()
      textarea.setSelectionRange(0, text.length)

      const successful = document.execCommand('copy')
      document.body.removeChild(textarea)

      successful ? resolve() : reject(new Error('Copy command failed'))
    } catch (err) {
      reject(err)
    }
  })
}

const copiedButtonTimeouts = new WeakMap()

/** 打开购物车时清理失效折扣码按顺序执行，避免和购物车请求互相覆盖 */
let copiedDiscountQueue = Promise.resolve()

function uniqueDiscountCodes(codes) {
  const result = new Map()
  codes.forEach(raw => {
    const code = String(raw || '').trim()
    const key = code.toUpperCase()
    if (code && !result.has(key)) result.set(key, code)
  })
  return [...result.values()]
}

function discountStateKey(cart) {
  const codes = (cart?.discount_codes || [])
    .map(
      item =>
        `${String(item?.code || '')
          .trim()
          .toUpperCase()}:${item?.applicable}`
    )
    .join(',')
  return `${codes}|${cart?.total_discount}|${cart?.total_price}`
}

function cartDiscountSectionIds() {
  const ids = new Set(['cart-drawer'])
  document.querySelectorAll('cart-drawer-items, cart-items').forEach(cartItems => {
    if (typeof cartItems.getSectionsToRender !== 'function') return
    cartItems.getSectionsToRender().forEach(section => {
      if (section.section) ids.add(section.section)
    })
  })
  return [...ids]
}

async function fetchDiscountCart() {
  const cartUrl = `${(window.routes && window.routes.cart_url) || '/cart'}.js`
  const response = await fetch(cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' })
  if (!response.ok) return null
  return response.json()
}

async function writeCartDiscount(discount) {
  const updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js'
  const response = await fetch(updateUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ discount })
  })
  if (!response.ok) return null
  const data = await response.json()
  if (data.status) return null
  return data
}

/** 同数量再提交一次，让 Shopify 重算折扣，并用这次响应里的 section 刷新界面 */
async function recalculateCartDiscount(cart) {
  const item = cart?.items?.[0]
  if (!item?.key) return cart
  const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change'
  const response = await fetch(changeUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      id: item.key,
      quantity: item.quantity,
      sections: cartDiscountSectionIds(),
      sections_url: window.location.pathname
    })
  })
  if (!response.ok) return cart
  const data = await response.json()
  if (data.status) return cart
  return data
}

function renderCartDiscountSections(data) {
  if (!data?.sections) {
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(cartItems => {
      if (typeof cartItems.onCartUpdate === 'function') cartItems.onCartUpdate()
    })
    return
  }

  const drawerHtml = data.sections['cart-drawer']
  if (drawerHtml) {
    const html = new DOMParser().parseFromString(drawerHtml, 'text/html')
    ;['cart-drawer-items', '.cart-drawer__footer'].forEach(selector => {
      const target = document.querySelector(selector)
      const source = html.querySelector(selector)
      if (target && source) target.replaceWith(source)
    })
    const sourceRecommendations = html.querySelector('.cart-recommendations-container')
    if (sourceRecommendations) {
      document.querySelectorAll('.cart-recommendations-container').forEach(target => {
        target.innerHTML = sourceRecommendations.innerHTML
      })
    }
    document.querySelectorAll('cart-drawer splide-slider').forEach(element => {
      element.slider?.refresh()
    })
    if (typeof window.toggleCartRecommendations === 'function') window.toggleCartRecommendations()
  }

  const cartItems = document.querySelector('cart-items')
  if (!cartItems || typeof cartItems.getSectionsToRender !== 'function') return
  cartItems.getSectionsToRender().forEach(section => {
    const sectionHTML = data.sections[section.section || section.id]
    if (!sectionHTML || !section.selector) return
    const sectionElement = section.id
      ? document.getElementById(section.id)?.querySelector(section.selector)
      : document.querySelector(section.selector)
    if (!sectionElement) return
    const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html').querySelector(section.selector)
    if (parsed) sectionElement.innerHTML = parsed.innerHTML
  })
}

function applicableDiscountCodes(cart) {
  return uniqueDiscountCodes(
    (cart?.discount_codes || []).filter(item => item && item.applicable !== false).map(item => item.code)
  )
}

/** 打开购物车时丢掉已失效的折扣码，并刷新弹窗和购物车页 */
window.removeInapplicableDiscountCodes = function removeInapplicableDiscountCodes() {
  copiedDiscountQueue = copiedDiscountQueue
    .catch(() => {})
    .then(async () => {
      const cart = await fetchDiscountCart()
      const codes = cart?.discount_codes || []
      if (!codes.length) return

      const alreadyInvalid = codes.some(item => item && item.applicable === false)
      let current = cart
      if (!alreadyInvalid) current = (await recalculateCartDiscount(cart)) || cart
      const hasInvalid = (current.discount_codes || []).some(item => item && item.applicable === false)
      if (!hasInvalid && discountStateKey(cart) === discountStateKey(current)) return

      if (hasInvalid) {
        const written = await writeCartDiscount(applicableDiscountCodes(current).join(','))
        if (!written) return
        current = (await recalculateCartDiscount(written)) || written
      }
      renderCartDiscountSections(current)
    })
  return copiedDiscountQueue
}

/**
 * 事件委托：监听折扣码按钮点击
 * 先同步展示 Copied 反馈（INP），再等待剪贴板/埋点，避免阻塞下一帧绘制。
 */
document.addEventListener('click', e => {
  const button = e.target.closest('.component-product-card__discount-code-button, .component-code-button')
  if (!button) return

  const discountCode = button.dataset?.value || button?.dataset?.value
  if (!discountCode) return

  e.preventDefault()

  const useToast = button.dataset.toast === 'true'
  const copiedClass = button.classList.contains('component-code-button')
    ? 'component-code-button--copied'
    : 'component-product-card__discount-code-button--copied'

  // 仍在用户手势内启动复制，避免丢失 clipboard 权限；UI 不等待 Promise。
  const copyPromise = copyTextProductCard(discountCode)

  button.setAttribute('aria-label', 'Discount code copied')

  if (!useToast) {
    button.classList.add(copiedClass)

    const previousTimeout = copiedButtonTimeouts.get(button)
    if (previousTimeout) clearTimeout(previousTimeout)

    copiedButtonTimeouts.set(
      button,
      setTimeout(() => {
        button.classList.remove(copiedClass)
        button.setAttribute('aria-label', 'Copy discount code')
        copiedButtonTimeouts.delete(button)
      }, 2000)
    )
  }

  copyPromise
    .then(() => {
      if (useToast) {
        const copiedMessage = 'Code Copied Successfully. Your discount will be auto-applied at checkout.'
        if (typeof window.showToast === 'function') {
          window.showToast({ message: copiedMessage, type: 'success', theme: 'light' })
        } else if (typeof window.showMessage === 'function') {
          window.showMessage(copiedMessage, 'success')
        }
        button.setAttribute('aria-label', 'Copy discount code')
      }

      if (!button.dataset.wdSent) return

      // 埋点移出交互关键路径，避免 JSON.parse / WDSendEvent 拖慢 INP。
      setTimeout(() => {
        try {
          const wdSent = JSON.parse(button.dataset.wdSent)
          const { event_name, ...rest } = wdSent
          window.WDSendEvent?.(event_name, rest)
        } catch (err) {
          console.error('Failed to parse wd-sent data:', err)
        }
      }, 0)
    })
    .catch(err => {
      // 失败：静默处理（发生概率 < 0.1%）
      console.error('Failed to copy discount code:', err)
      button.setAttribute('aria-label', 'Copy discount code')
      if (useToast) return
      button.classList.remove(copiedClass)
      const timeoutId = copiedButtonTimeouts.get(button)
      if (timeoutId) {
        clearTimeout(timeoutId)
        copiedButtonTimeouts.delete(button)
      }
    })
})

/**
 * @description 执行 Shopify Storefront GraphQL 请求
 * @param {string} shopDomain - Shopify 商店域名（不包含 .myshopify.com）
 * @param {string} storefrontApiToken - Storefront API 访问令牌
 * @param {string} query - GraphQL 查询字符串
 * @param {AbortSignal} [signal] - 可选的 AbortSignal，用于取消请求
 * @returns {Promise<Object>} GraphQL 响应数据
 * @throws {Error} 当请求失败时抛出错误
 * @global
 */
// eslint-disable-next-line no-unused-vars
async function fetchShopifyGraphQL({ query, variables }, signal = null) {
  if (!window.Shopify.shop || !window.STOREFRONT_API) {
    throw new Error('SHOP_DOMAIN or STOREFRONT_API is not defined')
  }
  const url = `https://${window.Shopify.shop}/api/2026-01/graphql.json`

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.STOREFRONT_API
    },
    body: JSON.stringify({ query, variables }),
    signal
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return await response.json()
}

/**
 * @description HTML update utility for switching new HTML nodes
 * @class HTMLUpdateUtility
 * @static
 * @method viewTransition
 * @method setInnerHTML
 */
// eslint-disable-next-line no-unused-vars
class HTMLUpdateUtility {
  /**
   * @description 视图过渡
   * 用于将一个 HTML 节点替换为一个新节点。
   * 新节点会作为旧节点的前一个同级节点插入，旧节点会被隐藏，然后旧节点会被移除。
   *
   * 该函数目前使用双缓冲机制，但一旦 View Transition API 得到更广泛的支持，就应该将其替换为 View Transition API。
   * View Transition API => https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   * @param {Element} oldNode
   * @param {Element} newContent
   * @param {Function[]} preProcessCallbacks
   * @param {Function[]} postProcessCallbacks
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach(callback => callback(newContent))

    const newNodeWrapper = document.createElement('div')
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML)
    const newNode = newNodeWrapper.firstChild

    // dedupe IDs
    const uniqueKey = Date.now()
    oldNode.querySelectorAll('[id], [form]').forEach(element => {
      element.id && (element.id = `${element.id}-${uniqueKey}`)
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`)
    })

    oldNode.parentNode.insertBefore(newNode, oldNode)
    oldNode.style.display = 'none'

    postProcessCallbacks?.forEach(callback => callback(newNode))

    setTimeout(() => oldNode.remove(), 500)
  }

  /**
   * @description 设置 inner HTML 并重新注入脚本标签以允许执行。默认情况下，使用 element.innerHTML 时脚本会被禁用。
   * @param {Element} element 元素
   * @param {string} html HTML 内容
   */
  static setInnerHTML(element, html) {
    element.innerHTML = html
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script')
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      })
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML))
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
    })
  }
}

// eslint-disable-next-line no-unused-vars
class CartPerformance {
  static #metric_prefix = 'cart-performance'

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`)
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    // eslint-disable-next-line no-unused-vars
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    })

    // eslint-disable-next-line no-unused-vars
    const endMarker = performance.mark(`${metricName}:end`)

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`)
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    // eslint-disable-next-line no-unused-vars
    const endMarker = performance.mark(`${metricName}:end`)

    performance.measure(metricName, startMarker.name, `${metricName}:end`)
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    // eslint-disable-next-line no-unused-vars
    const startMarker = performance.mark(`${metricName}:start`)

    callback()

    // eslint-disable-next-line no-unused-vars
    const endMarker = performance.mark(`${metricName}:end`)

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`)
  }
}

/**
 *
 * @param {string} proxy proxy name like 'rewards/smile'
 * @param {string} endpoint endpoint like '/customers'
 * @param {Object} query query like { include: 'vip_status'}
 * @param {string} method method like 'POST'
 * @param {Object} payload payload like { id: '1'}
 * @param {Object} mockData mock data like { '/customers': { customers: [{ id: 1, name: 'Test' }] } }
 * @returns {Promise<Object>} response data
 */

// eslint-disable-next-line no-unused-vars
async function waterdropAppApi({
  proxy,
  endpoint,
  query = {},
  method = 'GET',
  payload = {},
  timeout = 120000,
  mockData = {}
} = {}) {
  if (mockData[endpoint]) {
    return mockData[endpoint]
  }

  const body = { endpoint, method }
  if (query) body.query = query
  if (payload) body.payload = payload
  const isDev = false
  const baseUrl = isDev ? 'https://192.168.2.49/proxy' : '/apps/waterdrop'

  /*
   * 生产走 Shopify App Proxy，Shopify 会自动注入 shop / logged_in_customer_id。
   * isDev 直连本地 App，需手动带上这些 query，proxy.server 才能读到 shop。
   */
  let requestUrl = `${baseUrl}/${proxy}`
  if (isDev) {
    const params = new URLSearchParams()
    if (window.Shopify?.shop) params.set('shop', window.Shopify.shop)
    if (window.ShopifyCustomerId) params.set('logged_in_customer_id', String(window.ShopifyCustomerId))
    const qs = params.toString()
    if (qs) requestUrl += `?${qs}`
  }

  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeout)

  let res
  try {
    res = await fetch(requestUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: controller.signal
    })
  } catch (err) {
    clearTimeout(timer)
    if (err.name === 'AbortError') {
      throw new Error(`API ${endpoint}: request timeout`)
    }
    throw new Error(`API ${endpoint}: network error`)
  }

  clearTimeout(timer)

  if (res.status === 429) {
    throw new Error('Too many requests, please refresh the page and try again')
  }

  const response = await res.json()

  if (!res.ok || response.code !== 200) {
    throw new Error(`API ${endpoint}: ${response.message}`)
  }
  return response.data
}

class ComponentMessage extends HTMLElement {
  constructor() {
    super()
    this.hideTimer = null
    this.handleMessageShow = this.messageShow.bind(this)
    this.handleMessageHide = this.hide.bind(this)
  }

  connectedCallback() {
    this.messageEl = this.querySelector('.component-message__text')
    this.setupGlobalAPI()
    this.setupEventListeners()
  }

  setupEventListeners() {
    document.addEventListener('message:show', this.handleMessageShow)
    document.addEventListener('message:hide', this.handleMessageHide)
  }

  setupGlobalAPI() {
    window.showMessage = (msg, type, duration) => this.show(msg, type, duration)
    window.hideMessage = () => this.hide()
  }

  messageShow(event) {
    const { message, type, duration } = event.detail || {}
    this.show(message, type, duration)
  }

  show(message = '', type = 'info', duration = 3000) {
    if (!message) return

    clearTimeout(this.hideTimer)

    // 更新内容
    this.messageEl.textContent = message
    this.setAttribute('data-type', type)

    // 触发显示（避免闪烁）
    requestAnimationFrame(() => {
      this.classList.add('show')
    })

    if (duration > 0) {
      this.hideTimer = setTimeout(() => this.hide(), duration)
    }
  }

  hide() {
    this.classList.remove('show')
    clearTimeout(this.hideTimer)
  }

  disconnectedCallback() {
    clearTimeout(this.hideTimer)
    document.removeEventListener('message:show', this.handleMessageShow)
    document.removeEventListener('message:hide', this.handleMessageHide)
  }
}

if (!customElements.get('component-message')) {
  customElements.define('component-message', ComponentMessage)
}

/* --------------------------
 * Subscribe Form Web Component
 * ------------------------ */
class SubscribeForm extends HTMLElement {
  static EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  static pendingSubmit = new WeakMap()
  static fingerprintPromise = null

  static fingerprintScriptUrl() {
    if (this.cachedFingerprintUrl == null) {
      this.cachedFingerprintUrl =
        document.querySelector('script[data-fingerprint-url]')?.getAttribute('data-fingerprint-url') || ''
    }
    return this.cachedFingerprintUrl
  }

  static loadVisitorId() {
    if (this.fingerprintPromise) return this.fingerprintPromise

    const url = this.fingerprintScriptUrl()
    if (!url) return Promise.resolve('')

    this.fingerprintPromise = import(url)
      .then(fingerprintModule => {
        const FingerprintJS = fingerprintModule.default || fingerprintModule
        if (typeof FingerprintJS.load !== 'function') throw new Error('FingerprintJS did not load')
        return FingerprintJS.load({ monitoring: false })
      })
      .then(agent => agent.get())
      .then(result => result.visitorId || '')
      .catch(error => {
        this.fingerprintPromise = null
        throw error
      })

    return this.fingerprintPromise
  }

  // hCaptcha 写入 token 后会调用绑定时的 HTMLFormElement.submit。
  // 接住这次调用，避免整页跳转，并让 fetch 读到非空的 h-captcha-response。
  static installSubmitBridge() {
    if (this.submitBridgeInstalled) return
    const originalSubmit = HTMLFormElement.prototype.submit

    HTMLFormElement.prototype.submit = function submitBridge() {
      const pending = SubscribeForm.pendingSubmit.get(this)
      if (!pending) {
        originalSubmit.call(this)
        return
      }

      const field = this.elements['h-captcha-response']
      const token = typeof field?.value === 'string' ? field.value : ''
      if (!token) return

      SubscribeForm.pendingSubmit.delete(this)
      pending()
    }
    this.submitBridgeInstalled = true
  }

  constructor() {
    super()
    this.form = null
    this.submitButton = null
    this.isSubmitting = false
    this.visitorId = ''
    this.handleSubmit = this.submit.bind(this)
  }

  connectedCallback() {
    this.form = this.querySelector('form')
    this.submitButton = this.querySelector('button[type="submit"]')
    if (!this.form) return
    this.form.addEventListener('submit', this.handleSubmit)
    this.setSubmitButtonLoading(false)
    this.ensureVisitorId()
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit)
  }

  async submit(ev) {
    ev.preventDefault()
    ev.stopImmediatePropagation()
    const errorMessage = window.accessibilityStrings.subscriptionError || 'Subscription failed. Please try again later.'
    if (this.isSubmitting) return

    const email = this.form.querySelector('input[name="email"]')?.value.trim() || ''
    if (!SubscribeForm.EMAIL_PATTERN.test(email)) {
      this.showSubmitMessage(
        window.accessibilityStrings.subscriptionInvalidEmail || 'Please enter a valid email address.',
        'error'
      )
      return
    }

    this.setSubmitButtonLoading(true)

    try {
      await this.ensureVisitorId()
      await this.protectCaptcha()
      await this.postSubscription(errorMessage)
    } catch (error) {
      console.error(error)
      this.showSubmitMessage(errorMessage, 'error')
    } finally {
      this.setSubmitButtonLoading(false)
    }
  }

  async ensureVisitorId() {
    if (this.visitorId) return

    try {
      const visitorId = await SubscribeForm.loadVisitorId()
      if (!this.isConnected || !visitorId) return
      this.visitorId = visitorId
    } catch (error) {
      console.error(error)
    }
  }

  protectCaptcha() {
    const protect = window.Shopify?.captcha?.protect
    if (typeof protect !== 'function') return Promise.resolve()

    SubscribeForm.installSubmitBridge()

    return new Promise((resolve, reject) => {
      let settled = false
      let timeoutId = 0
      const settle = callback => {
        if (settled) return
        settled = true
        window.clearTimeout(timeoutId)
        SubscribeForm.pendingSubmit.delete(this.form)
        callback()
      }

      timeoutId = window.setTimeout(() => {
        settle(() => reject(new Error('CAPTCHA timed out')))
      }, 120000)

      SubscribeForm.pendingSubmit.set(this.form, () => settle(resolve))

      try {
        protect(this.form, () => {
          const { submit } = this.form
          if (submit === HTMLFormElement.prototype.submit) {
            settle(() => reject(new Error('CAPTCHA did not bind')))
            return
          }
          submit.call(this.form)
        })
      } catch (error) {
        settle(() => reject(error))
      }
    })
  }

  async postSubscription(errorMessage) {
    const eventSource = this.submitButton?.getAttribute('data-wd-subscribe-event')
    if (eventSource && typeof window.WDSendEvent === 'function') {
      window.WDSendEvent(WD_EVENT_SUBSCRIBE_CLICK, { event_source: eventSource })
    }

    const formData = new FormData(this.form)
    const { action } = this.form
    const headers = { Accept: 'application/json' }
    if (this.visitorId) headers['X-Visitor-Id'] = this.visitorId
    const response = await fetch(action, { method: 'POST', body: formData, headers })

    if (!response.ok) {
      this.showSubmitMessage(errorMessage, 'error')
      return
    }

    const result = await response.json()
    if (result.code === 200 && result?.data) {
      const { prevState } = result.data
      this.handleSubscribeSuccess(eventSource, prevState)
      return
    }

    this.showSubmitMessage(result.message || errorMessage, 'error')
  }

  // prevState: INVALID NOT_SUBSCRIBED PENDING SUBSCRIBED UNSUBSCRIBED
  /**
   * @description Handle subscribe success event and send event to GA4
   * prevState: INVALID NOT_SUBSCRIBED PENDING SUBSCRIBED UNSUBSCRIBED
   * eventLabel: 1.customer is not subscribed to email marketing.
   * eventLabel: 2.customer is not subscribed to email marketing but was previously subscribed.
   * eventLabel: 3.customer is subscribed to email marketing.
   * @param {string} eventSource
   * @param {string} prevState
   */
  handleSubscribeSuccess(eventSource, prevState) {
    if (eventSource && typeof window.WDSendEvent === 'function') {
      let eventLabel = 3
      if (prevState === 'INVALID' || prevState === 'NOT_SUBSCRIBED') eventLabel = 1
      else if (prevState === 'PENDING' || prevState === 'UNSUBSCRIBED') eventLabel = 2
      window.WDSendEvent(WD_EVENT_SUBSCRIBE_SUCCESS, { event_source: eventSource, event_label: eventLabel })
    }

    const successMessage = window.accessibilityStrings.subscriptionSuccess || 'Subscription successful!'
    this.showSubmitMessage(successMessage, 'success')
    // 订阅成功事件
    this.dispatchEvent(
      new CustomEvent('subscribe-form:success', {
        bubbles: true,
        detail: {
          eventSource,
          prevState,
          message: successMessage,
          email: this.form.querySelector('input[name="email"]')?.value.trim() || ''
        }
      })
    )
  }

  showSubmitMessage(message, type) {
    if (typeof window.showToast !== 'function') return
    window.showToast({ message, type, theme: 'light', target: this })
  }

  setSubmitButtonLoading(isLoading) {
    this.isSubmitting = isLoading
    this.toggleAttribute('submitting', isLoading)

    if (!this.submitButton) return

    this.submitButton.disabled = isLoading
    this.submitButton.classList.toggle('loading', isLoading)
    this.submitButton.setAttribute('aria-busy', isLoading.toString())
  }
}

if (!customElements.get('subscribe-form')) {
  customElements.define('subscribe-form', SubscribeForm)
}

// ========== Shopify Account ==========
// 统一管理 Shopify Account 弹窗入口、点击埋点和登录成功埋点。
class WDShopifyAccount {
  static PENDING_SOURCE_KEY = 'wd_shopify_account_login_source'
  static AUTH_STATE_KEY = 'wd_shopify_account_logged_in'

  constructor() {
    this.components = Array.from(document.querySelectorAll('[data-wd-account-component]'))
  }

  init() {
    this.trackSuccessfulLogin()
    if (!this.components.length) return

    this.components.forEach(component => {
      component.addEventListener('open', () => this.handleOpen(component))
      component.addEventListener('close', () => this.handleClose(component))
    })
  }

  // 登录弹窗打开时关闭 Header hover 弹窗，并在登录期间阻止 hover 再次打开。
  handleOpen(component) {
    const header = component.closest('shop-header')
    if (header && typeof header.setAccountSheetOpen === 'function') {
      header.setAccountSheetOpen(true)
    } else if (header && typeof header.closeAccountPopup === 'function') {
      header.closeAccountPopup()
    }

    const clickEvent = component.dataset.loginClickEvent
    if (clickEvent && typeof window.WDSendEvent === 'function') {
      window.WDSendEvent(clickEvent)
    }

    if (component.dataset.customerLoggedIn === 'true') return

    try {
      window.sessionStorage.setItem(
        WDShopifyAccount.PENDING_SOURCE_KEY,
        component.dataset.loginEventSource || window.location.pathname
      )
    } catch (error) {
      console.warn('Unable to persist Shopify account login source.', error)
    }
  }

  handleClose(component) {
    const header = component.closest('shop-header')
    if (header && typeof header.setAccountSheetOpen === 'function') {
      header.setAccountSheetOpen(false)
    } else if (header && typeof header.closeAccountPopup === 'function') {
      header.closeAccountPopup()
    }
  }

  getAuthState() {
    try {
      return window.localStorage.getItem(WDShopifyAccount.AUTH_STATE_KEY)
    } catch (error) {
      console.warn('Unable to read Shopify account auth state.', error)
      return null
    }
  }

  setAuthState(isLoggedIn) {
    try {
      window.localStorage.setItem(WDShopifyAccount.AUTH_STATE_KEY, isLoggedIn ? 'true' : 'false')
    } catch (error) {
      console.warn('Unable to persist Shopify account auth state.', error)
    }
  }

  consumePendingEventSource() {
    try {
      const eventSource = window.sessionStorage.getItem(WDShopifyAccount.PENDING_SOURCE_KEY)
      window.sessionStorage.removeItem(WDShopifyAccount.PENDING_SOURCE_KEY)
      return eventSource || window.location.pathname
    } catch (error) {
      console.warn('Unable to read Shopify account login source.', error)
      return window.location.pathname
    }
  }

  // 根据「未登录 → 已登录」状态跳变上报成功事件；首次进入已登录会话只同步状态，不上报。
  trackSuccessfulLogin() {
    const signedInElement = document.querySelector('[data-customer-logged-in="true"][data-customer-id]')
    const isLoggedIn = Boolean(signedInElement)
    const previousAuthState = this.getAuthState()

    if (previousAuthState === 'false' && isLoggedIn && typeof window.WDSendEvent === 'function') {
      window.WDSendEvent('wd_login_success', {
        event_action: signedInElement.dataset.customerId,
        event_label: this.consumePendingEventSource()
      })
    } else if (isLoggedIn) {
      try {
        window.sessionStorage.removeItem(WDShopifyAccount.PENDING_SOURCE_KEY)
      } catch (error) {
        console.warn('Unable to clear Shopify account login source.', error)
      }
    }

    this.setAuthState(isLoggedIn)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new WDShopifyAccount().init()
})
